import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class Line extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'line'
            }
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Line)}